import { render, staticRenderFns } from "./DictionaryInformationForm.vue?vue&type=template&id=37e0b358&scoped=true&"
import script from "./DictionaryInformationForm.vue?vue&type=script&lang=js&"
export * from "./DictionaryInformationForm.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryInformationForm.vue?vue&type=style&index=0&id=37e0b358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0b358",
  null
  
)

export default component.exports